import React from 'react';
import StepIndicator from '../../../components/ui/StepIndicator';

const DEFAULT_STEP_LABELS = ['Knowledge', 'Importar', 'Agente'];

function WizardShell({
  title,
  subtitle,
  step,
  totalSteps,
  showSteps = true,
  stepLabels = DEFAULT_STEP_LABELS,
  children,
}) {
  return (
    <div className="surface-card p-8 shadow-card-md">
      <div className="mb-6">
        {showSteps && (
          <StepIndicator
            step={step}
            totalSteps={totalSteps}
            labels={stepLabels.slice(0, totalSteps)}
          />
        )}
        <h1 className="text-2xl font-bold text-content-primary mb-2">{title}</h1>
        {subtitle && <p className="text-content-muted text-sm">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export default WizardShell;
